import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';
import { createFormData } from '../helpers/createFormdata';

type UpdateSectorParams = {
    propId: string;
    areaId: string;
    sectorId: string;
    data: {
        name: string;
        areaId: string;
        size: number;
        plantingDate: string;
        amountOfPlants: number;
        plantSpacing: number;
        lineSpacing: number;
    };
};

export function useUpdateSector() {
    const queryClient = useQueryClient()
    const forBinding = useForBindingId();
    return useMutation({
        mutationFn: async ({ propId, areaId, sectorId, data }: UpdateSectorParams) => {
            try {
                const formData = createFormData(data);
                return (await api.put(`/user/prop/${propId}/area/${areaId}/sector/update/${sectorId}`, formData, {
                    params: { forBinding },
                })).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao atualizar setor');
            }
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['sectors'] });
            queryClient.invalidateQueries({ queryKey: ['propertyId', variables.propId] })
        },
        onError: error => console.error('Erro ao atualizar setor:', getApiErrorMessage(error, 'Erro ao atualizar setor')),
    });
}
